import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { LearningPathMultiStepForm } from '../../app/components/learning-path/learning-path-multi-step-form';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/learning-paths/$pathId')({
  component: LearningPathDetailRoute,
});

function LearningPathDetailRoute() {
  const { pathId } = Route.useParams();
  const navigate = useNavigate({ from: '/learning-paths/$pathId' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');
  const { data, isLoading } = trpc.learningPaths.getById.useQuery({ pathId });
  const path = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/learning-paths', replace: true });
  };

  const handleSubmit = async () => {
    await utils.learningPaths.list.invalidate();
    await utils.learningPaths.getById.invalidate({ pathId });
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('learningPaths.list.modal.editTitle')}
      size="xl"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('learningPaths.form.loading')}
          </div>
        ) : path ? (
          <LearningPathMultiStepForm
            defaultValues={path}
            onSubmit={handleSubmit}
            onClose={handleClose}
            isEditing
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('learningPaths.form.notFound')}
          </div>
        )
      }
      footer={<></>}
    />
  );
}
